import script from "./LichSuGopYKienNghi.vue?vue&type=script&setup=true&lang=js"
export * from "./LichSuGopYKienNghi.vue?vue&type=script&setup=true&lang=js"

import "./LichSuGopYKienNghi.vue?vue&type=style&index=0&id=45971554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45971554"]])

export default __exports__